import { render } from "./PassThrough.vue?vue&type=template&id=5ca4d156"
const script = {}

import "./PassThrough.vue?vue&type=style&index=0&id=5ca4d156&lang=scss"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__